/**
 * Page Transitions Utility
 * Handles smooth page transitions with fade-out/fade-in effects
 */

/**
 * Navigate to a new page with smooth transition
 * @param url - The URL to navigate to
 * @param delay - Delay before navigation (ms) - default 300ms
 */
export function navigateWithTransition(url: string, delay: number = 300): void {
  // Add exit animation class
  document.body.classList.add('page-exit')
  
  // Navigate after animation completes
  setTimeout(() => {
    window.location.href = url
  }, delay)
}

/**
 * Initialize page transitions
 * Sets up event listeners for smooth navigation
 */
export function initPageTransitions(): void {
  // Check if we're on the home page
  const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index.html';
  
  if (isHomePage) {
    // Mark as home page to enable navbar animation
    document.body.classList.add('home-page')
    
    // After animation completes, mark navbar as loaded to prevent re-animation
    setTimeout(() => {
      document.body.classList.add('navbar-loaded')
    }, 500)
  } else {
    // On other pages, mark immediately so navbar never animates
    document.body.classList.add('navbar-loaded')
  }

  // Add page-content class to main content areas
  const mainContent = document.querySelector('#app, #iniciar-estudio-app, #central-pagos-app, #status-verify-app, #status-dashboard-app, #upload-documents-app, #login-app')
  if (mainContent) {
    mainContent.classList.add('page-content')
  }
}

/**
 * Intercept navigation and add transition
 * @param callback - Function that performs the navigation
 */
export function withTransition(callback: () => void): void {
  document.body.classList.add('page-exit')
  setTimeout(() => {
    callback()
  }, 300)
}
